import { DialogContent, Box, Typography, Grid } from '@mui/material'
import UploadFileItem from 'components/Input/UploadFile'
import { RiArrowLeftSFill, RiArrowRightSFill } from 'react-icons/ri'
import { I18n, Extension } from 'utilities/utilities'
import TableActivityGanttChart from '../../components/Table/TableActivityGanttChart'

function TableGanttChart(props) {
    const { dataActivity } = props
    return (
        <DialogContent
            sx={{
                minWidth: "600px",
            }}
        >
            <TableActivityGanttChart
                data={dataActivity}
                onDelete={() => { }}
                onEdit={() => { }}
                nEditID={0}
                nEditParentID={0}
            />
        </DialogContent>
    )
}

export default TableGanttChart